<template lang="html">
	<div class="exchangeContainer">
		<div class="title">热门兑换</div>
		<div class="sub-title">当您是君弘会员银卡及以上级别时，您将获得君弘积分专属会员特权。
您的君弘积分可用于君弘积分商城进行礼品兑换。</div>
		<div class="exchangeBox">
			<div class="container" v-for="(item,index) in exchangeArray" v-if="index < 4">
				<div class="imgContainer">
					<img v-bind:src="imgSrc+item.PIC_URL.split('|')[0]" />
					<!-- <img src="../../assets/img/index-exchange.png" /> -->
				</div>
				<div class="textContainer">
					<div class="text-title">{{item.TITLE}}</div>
					<div class="text-content">{{item.SUB_TITLE}}</div>
					<a v-bind:href="item.PROD_CODE?'https://jf.gtja.com/mobile/mall/dist/index.html#/proDetail/normalAct/'+item.PROD_CODE+'/jhjfmob':'javascript:void(0)'"><div class="exBtn">兑换</div></a>
				</div>
			</div>
			<!-- <div class="container">
				<div class="imgContainer">
					<img src="../../assets/img/index-exchange.png" />
				</div>
				<div class="textContainer">
					<div class="text-title">限量爆款-灵犀手办</div>
					<div class="text-content">真的很好吃，很值，这质量和口感是越吃越好吃，不会像其他蛋卷越吃越难吃,越吃越亏
					</div>
					<div class="exBtn">兑换</div>
				</div>
			</div> -->
		</div>
	</div>
</template>
<script>
	import {commonPicUrl} from '../../common/url.js'
	export default {
	  	name: 'exchange',
	  	data(){
		  	return{
		  		imgSrc:commonPicUrl,	
		  	}
	  	},
	  	props:['exchangeArray'],
	}
</script>
<style lang="less" scoped>
	.exchangeContainer{
		padding:0px 40px;
		width:100%;
		.title{
			width:100%;
			height:40px;
			font-size:32px;
			color:#ad8f5a;
			letter-spacing:0;
			line-height:40px;
			text-align:left;
			font-weight:bold;
		}
		.sub-title{
			margin-top:20px;
			width:100%;
			font-size:24px;
			color:#999999;
			letter-spacing:0;
			line-height:40px;
			text-align:left;
		}
		.exchangeBox{
			margin-top:20px;
			width:100%;
			.container{
				width:100%;
				margin-bottom:20px;
				display:inline-block;
				.imgContainer{
					float:left;
					width:30%;
					img{
						width:100%;
						max-height:200px;
					}
				}
				.textContainer{
					float:right;
					width:70%;
					padding-left:20px;
					text-align:left;
					.text-title{
						font-size:28px;
						color:#333333;
						letter-spacing:0;
						line-height:40px;
						height:40px;
						text-overflow:ellipsis;
						overflow: hidden;
				    	display: -webkit-box;
		    			-webkit-line-clamp: 1;
		    			-webkit-box-orient: vertical;
		    			word-break:break-all;
		    			font-weight:bold;
					}
					.text-content{
						margin-top:5px;
						font-size:24px;
						color:#666666;
						letter-spacing:0.08px;
						line-height:40px;
						height:80px;
						overflow: hidden;
				    	display: -webkit-box;
		    			-webkit-line-clamp: 2;
		    			-webkit-box-orient: vertical;
		    			word-break:break-all;
					}
					.exBtn{
						background-image:linear-gradient(90deg, #f1e3bb 0%, #e0c385 100%);
						border-radius:10px;
						width:160px;
						height:70px;
						float:right;
						margin-top:5px;
						line-height:70px;
						text-align:center;
						color:#fff;
						font-size:28px;
						letter-spacing:1px;
					}
				}
			}
		}
		
	}
</style>


// WEBPACK FOOTER //
// src/components/home/exchange.vue